import React, { useEffect, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { useNavigate } from 'react-router-dom'
import config, { axiosInstance  } from '../Config'
import Loader from '../Loader'
import { toast } from 'react-toastify'
import secureLocalStorage from 'react-secure-storage'


const AddRole = () => {

    const navigate = useNavigate()
    const users = secureLocalStorage.getItem("admin_credentials");

    const [allModule, setModules] = useState(
        [
            {
                id: 1,
                module: "Dashboard",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: false, isEdit: false, isDelete: false
            },
            {
                id: 2,
                module: "Videos",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: true, isEdit: true, isDelete: true
            },
            {
                id: 3,
                module: "Generated Images",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: false, isEdit: false, isDelete: true
            },
            {
                id: 4,
                module: "Generated Videos",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: false, isEdit: false, isDelete: true
            },
            {
                id: 5,
                module: "AI Chats",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: false, isEdit: false, isDelete: false
            },
            {
                id: 6,
                module: "Staff",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: true, isEdit: true, isDelete: true
            },
            {
                id: 7,
                module: "Roles & Permissions",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: true, isEdit: true, isDelete: true
            },
            {
                id: 8,
                module: "Audit Logs",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: false, isEdit: false, isDelete: false
            },
            {
                id: 9,
                module: "Users",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: false, isEdit: false, isDelete: false
            },
            {
                id: 10,
                module: "Settings - AI Token Limits",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: false, isEdit: true, isDelete: false
            },
            {
                id: 11,
                module: "Settings - Manage AI Keys",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: true, isEdit: true, isDelete: true
            },
            {
                id: 12,
                module: "Settings - Restricted Words",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: true, isEdit: true, isDelete: true
            },
            {
                id: 13,
                module: "Settings - Privacy Policy",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: false, isEdit: true, isDelete: false
            },
            {
                id: 14,
                module: "Settings - Category",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: true, isEdit: true, isDelete: true
            },
            {
                id: 15,
                module: "Tutors",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: true, isEdit: true, isDelete: true
            },
            {
                id: 18,
                module: "Payments",
                view: 0, add: 0, edit: 0, delete: 0,
                isAdd: false, isEdit: false, isDelete: false
            },
        ]
    )

    const [roleName, setRoleName] = useState("")
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        document.title = "Add Role | Mindora"
    }, [])

    const toggleColumn = (property) => {
        const flag = property === 'view' ? null : `is${property.charAt(0).toUpperCase() + property.slice(1)}`
        const relevant = allModule.filter(m => flag ? m[flag] : true)
        const allChecked = relevant.every(m => m[property] === 1)
        setModules(prev => prev.map(mod => {
            if (flag && !mod[flag]) return mod
            return { ...mod, [property]: allChecked ? 0 : 1 }
        }))
    }

    // changeing permissions
    const updateModule = (moduleId, property) => {
        const updatedModules = allModule.map(mod => {
            if (mod.id === moduleId) {
                return { ...mod, [property]: (mod[property] === 0 ? 1 : 0) };
            }
            return mod;
        });
        setModules(updatedModules);
    };

    const addRolesPermissions = async () => {
        setError(false)

        if (!roleName.trim()) { setError(true); return }

        try {
            setLoading(true)

            const permissions = allModule.map(mod => ({
                moduleId: mod.id,
                module:   mod.module,
                view:     mod.view,
                add:      mod.add,
                edit:     mod.edit,
                delete:   mod.delete,
            }))

            const response = await axiosInstance.post('roles', { roleName, permissions }, {
                headers: { Authorization: `Bearer ${users?.token}` }
            })

            toast.success(response.data?.message || 'Role Added Successfully!')
            setTimeout(() => navigate(`${config.appUrl}roles`), 1000)

        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message || 'Something went wrong!')
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {loading && <Loader />}
            
            <ContainerDashboard title="Add Roles & Permissions" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">

                        <div className="col-md-12 ">
                            <div className="p-4 py-5 bg-gradientt rounded-4">

                                <div className='d-md-flex justify-content-between align-items-start mb-4'>
                                    <div className="ps-section__search  d-flex justify-content-end mb-4">
                                        <form
                                            className="ps-form--search-simple"
                                        >
                                            <label htmlFor="roleName" className="form-label fw-semibold mb-1 d-block" style={{ fontSize: '14px', color: '#1a1a2e' }}>Role Name <span className="text-danger">*</span></label>
                                            <input
                                                id="roleName"
                                                className="form-control bg-white"
                                                type="text"
                                                placeholder="Enter Role Name"
                                                value={roleName}
                                                onChange={(e) => setRoleName(e.target.value)}
                                                required
                                                aria-required="true"
                                            />
                                            {error && <span className='badge text-danger'>Role Name is required.</span>}
                                        </form>
                                    </div>
                                    <div className='text-center'>
                                        <button type="button" onClick={addRolesPermissions} className="button  btn-green color-white">
                                            {/* <i className='icon- me-3 fs-5'></i> */}
                                            Save Data</button>
                                        <button type="button" onClick={() => navigate(-1)}
                                            className="button ms-3"
                                            style={{ background: '#1a1a2e', color: '#fff', borderRadius: '12px' }}>
                                            <i className='icon-arrow-left me-2'></i>
                                            Back</button>
                                    </div>

                                </div>

                                <div className="ps-section__content">
                                    <div className="table-responsive">
                                        <table className="table custom-table text-center">
                                            <thead>
                                                <tr>
                                                    <th className='text-start fw-bold text-green border-end'>Modules</th>
                                                    {['view', 'add', 'edit', 'delete'].map(col => {
                                                        const flag = col === 'view' ? null : `is${col.charAt(0).toUpperCase() + col.slice(1)}`
                                                        const relevant = allModule.filter(m => flag ? m[flag] : true)
                                                        const allChecked = relevant.length > 0 && relevant.every(m => m[col] === 1)
                                                        return (
                                                            <th key={col} className='fw-bold text-dark'>
                                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                                    {col.charAt(0).toUpperCase() + col.slice(1)}
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={allChecked}
                                                                        onChange={() => toggleColumn(col)}
                                                                        title={allChecked ? 'Uncheck All' : 'Check All'}
                                                                        style={{ cursor: 'pointer', width: 15, height: 15 }}
                                                                    />
                                                                </div>
                                                            </th>
                                                        )
                                                    })}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {allModule.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <th className='text-start border-end'>
                                                                <input
                                                                    id="roleId"
                                                                    value={item.id}
                                                                    type='hidden'
                                                                    className="display-none bd-text-center"
                                                                />
                                                                {item.module}
                                                            </th>

                                                            <td data-column="View" >
                                                                <div className="d-flex align-items-center pt-2 justify-content-center ps-5 ">
                                                                    <div className="form-check form-switch form-switch-md">
                                                                        <input
                                                                            type="checkbox"
                                                                            className={`form-check-input fs-2 ${item.id}`}
                                                                            checked={item.view === 1}
                                                                            onChange={() => updateModule(item.id, 'view')}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td data-column="Add">
                                                                {
                                                                    item.isAdd ?
                                                                        <div className="d-flex align-items-center pt-2 justify-content-center ps-5 ">
                                                                            <div className="form-check form-switch form-switch-md">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input fs-2"
                                                                                    checked={item.add === 1}
                                                                                    onChange={() => updateModule(item.id, 'add')}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        : <div className='ms-0 mt-4'>--</div>
                                                                }
                                                            </td>
                                                            <td data-column="Edit">
                                                                {
                                                                    item.isEdit ?
                                                                        <div className="d-flex align-items-center pt-2 justify-content-center ps-5 ">
                                                                            <div className="form-check form-switch form-switch-md">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input fs-2"
                                                                                    checked={item.edit === 1}
                                                                                    onChange={() => updateModule(item.id, 'edit')}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        : <div className='ms-0 mt-4'>--</div>
                                                                }
                                                            </td>

                                                            <td data-column="Delete">
                                                                {
                                                                    item.isDelete ?
                                                                        <div className="d-flex align-items-center pt-2 justify-content-center ps-5 ">
                                                                            <div className="form-check form-switch form-switch-md">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input fs-2"
                                                                                    checked={item.delete === 1}
                                                                                    onChange={() => updateModule(item.id, 'delete')}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        : <div className='ms-0 mt-4'>--</div>
                                                                }
                                                            </td>

                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default AddRole
